import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { CertificadoNoAdeudoComponent } from "./certificado-no-adeudo/certificado-no-adeudo.component";
import { VisorComponent } from "./visor/visor.component";
import { ConsultaLecturasComponent } from "./consulta-lecturas/consulta-lecturas.component";
import { GeneraRutasComponent } from "./genera-rutas/genera-rutas.component";
import { ConsumosRowComponent } from "./consumos-row/consumos-row.component";
import { ConsumosGridComponent } from "./consumos-grid/consumos-grid.component";
import { VentanillaComponent } from './ventanilla/ventanilla.component';
import { InformacionComponent } from './informacion/informacion.component';
// import { EstadocuentamasivoComponent } from './estadocuentamasivo/estadocuentamasivo.component';
import { BajaDeCuentaComponent } from './baja-de-cuenta/baja-de-cuenta.component';
import { AltaMedidoresComponent } from '../componentes/alta-medidores/alta-medidores.component';
import { ManualesComponent } from '../componentes/manuales/manuales.component';
import { EstadoCuentaOnlineComponent } from "./estado-cuenta-online/estado-cuenta-online.component";
import { AuthGuard } from "../_helpers/auth.guard";




const routes: Routes = [
  {
    
    path: "",
    children: [
      {
        path: "generarutas",
        component: GeneraRutasComponent,
      },
      {
        path: "certificado-no-adeudo",
        component: CertificadoNoAdeudoComponent,
      },
      {
        path: "visor",
        component: VisorComponent,
      },
      {
        path: "informacion",
        component: InformacionComponent,
      },
      {
        path: "ventanilla",
        component: VentanillaComponent,
      },
      {
        path: "consultalecturas",
        component: ConsultaLecturasComponent,
      },
      {
        path: "alta-medidores",
        component: AltaMedidoresComponent,
      },
      {
        path: "baja-de-cuenta",
        component: BajaDeCuentaComponent,
      },
      

      {
        path: "consumos-row",
        component: ConsumosRowComponent,
      },
      {
        path: "consumos-grid",
        component: ConsumosGridComponent,
      },
      {
        path: "manuales",
        component: ManualesComponent,
      },
      {
        path: "manuales",
        component: ManualesComponent,
      },
      {
        path: "estadocuentaonline",
        component: EstadoCuentaOnlineComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "estadocuentaonline/:cuentaagua", //ruta expres de pago .
        component: EstadoCuentaOnlineComponent,
        canActivate: [AuthGuard]
      },
      { path: ':cuentaagua', pathMatch: 'full', redirectTo: 'estadocuentaonline/:cuentaagua' }, // Redirecciona directamente
      
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ComponentesRoutingModule {}
